import React, { Component } from 'react';
import Link from 'react-router/lib/Link';
import { get } from 'Language';

class ProfileMenu extends Component {

    render() {
        const { data, location } = this.props;

        const makeActive = (uri) => {
            return uri === location.pathname ? 'active' : null;
        }

        return (
            <div>
                <ul className="nav nav-pills nav-stacked nav-custom">
                    <li className={makeActive('/profile')}>
                        <Link to="/profile">
                            <span className="fa fa-user white"></span>&nbsp;
                            { get('PROFILE_LINK') }
                        </Link>
                    </li>

                    <li className={makeActive('/profile/change-password')}>
                        <Link to="/profile/change-password">
                            <span className="fa fa-lock white"></span>{' '}
                            { get('CHANGE_PASSWORD_LINK') }
                        </Link>
                    </li>

                    {/*<li>
                        <Link to="/profile/download-caliper">
                            <span className="fa fa-link"></span>&nbsp;
                            Download Caliper Guide
                        </Link>
                    </li>*/}

                    { parseInt(data.fitter, 0) > 0
                        ? <li className={makeActive('/profile/users')}>
                            <Link to="/profile/users">
                                <span className="fa fa-list white"></span>&nbsp;
                                { get('MY_USERS_LINK') }
                            </Link>
                        </li>
                        : null
                    }

                </ul>

                <hr/>

                <ul className="nav nav-pills nav-stacked nav-custom">

                    <li className={makeActive('/profile/stance')}>
                        <Link to="/profile/stance">
                            <span className="fa fa-flag"></span>&nbsp;
                            { get('STANCE_WIDTH_LINK') } ($150)
                        </Link>
                    </li>

                    <li className={makeActive('/profile/gripsize')}>
                        <Link to="/profile/gripsize">
                            <span className="fa fa-flag"></span>&nbsp;
                            { get('GRIPSIZE_LINK') } ($150)
                        </Link>
                    </li>
                </ul>
            </div>
        );
    }
}

export default ProfileMenu



// WEBPACK FOOTER //
// ./src/profile/components/ProfileMenu.js